// extracted by mini-css-extract-plugin
export default {"selectBox":"select_selectBox__0dpMF","solid":"select_solid__yAVSr","outline":"select_outline__FKNKh","arrow":"select_arrow__rh3YX"};